module.exports = "/images/ferramentas.svg?aee6e75e9a07a446af4c3f3f31189c22";